export const appName = 'TDOS';
export const version = '3.4.46';
